var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "deviceListBox",
    staticClass: "device_list pr"
  }, [_c('div', {
    staticClass: "table_box"
  }, [_c('el-table', {
    ref: "topicTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deviceList,
      "empty-text": _vm.$t('lang.noData'),
      "border": "",
      "row-key": "peerId",
      "expand-row-keys": _vm.expands
    },
    on: {
      "row-click": _vm.expandDetail,
      "header-dragend": _vm.setBehavior
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "width": "10"
    }
  }, [[_c('div', {
    staticClass: "video_detail",
    class: {
      show: _vm.expands.length
    }
  }, [_vm.receiverInfoWrap ? _c(_vm.receiverInfoWrap, {
    tag: "component",
    staticClass: "source-list-box",
    attrs: {
      "testVal": _vm.expands,
      "checkSourceIdFlag": true,
      "pn": "hm"
    }
  }) : _vm._e()], 1)]], 2), _c('el-table-column', {
    attrs: {
      "width": "35",
      "label": "",
      "class-name": "pink"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "popper-class": "pinkBox",
            "placement": "top-start"
          }
        }, [scope.row.pinked ? _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(_vm.$t('lang.Untop')))]) : _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(" " + _vm._s(_vm.$t('lang.Top')) + "("), _c('span', {
          staticClass: "pinkedNum",
          class: _vm.pinkedNum >= _vm.pinnedDevicesNum ? 'maxNum' : ''
        }, [_vm._v(_vm._s(_vm.pinkedNum))]), _c('span', {
          class: _vm.pinkedNum >= _vm.pinnedDevicesNum ? 'maxNum' : ''
        }, [_vm._v("/" + _vm._s(_vm.pinnedDevicesNum))]), _vm._v(")")]), _c('span', {
          staticClass: "iconfont pinkIcon icon-pin",
          class: {
            'icon-a-pinon': scope.row.pinked,
            'disabled': _vm.pinkedNum >= _vm.pinnedDevicesNum && !scope.row.pinked
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.setSourceToTop(scope.row);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.pink) + " ")])])];
      }
    }])
  }), _vm._l(_vm.titleArr, function (item, index) {
    return [item ? _c('el-table-column', {
      key: index,
      attrs: {
        "class-name": item.name,
        "label": _vm.$t(`lang.${item.name}`),
        "width": item.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (scope) {
          return [_vm.dropCol[index] == "thumbnailObj" ? _c('div', {
            class: [_vm.dropCol[index]]
          }, [_vm.rowPreviewDisabled(scope.row) ? _c('div', {
            staticClass: "live-preview-disabled-hint",
            attrs: {
              "data-testid": "live-preview-disabled-hint"
            }
          }, [_c('el-tooltip', {
            attrs: {
              "effect": "dark",
              "placement": "top",
              "popper-class": "live-preview-tip",
              "content": _vm.$t('lang.livePreviewDisabledHint')
            }
          }, [_c('i', {
            staticClass: "iconfont icon-Hide lpd-icon"
          })])], 1) : !scope.row.thumbnailObj || scope.row.thumbnailObj && scope.row.thumbnailObj.startsWith('icon-') ? _c('div', {
            staticClass: "thumbnailIconBox",
            class: {
              'offline': scope.row.status == 0 || scope.row.status == 3
            },
            attrs: {
              "title": scope.row['peerId']
            }
          }, [scope.row.thumbnailObj === 'icon-a-onlinenosource' ? _c('svg', {
            staticClass: "svg-icon",
            attrs: {
              "aria-hidden": "true"
            }
          }, [_c('use', {
            attrs: {
              "xlink:href": "#icon-a-onlinenosource"
            }
          })]) : _c('span', {
            staticClass: "iconfont",
            class: scope.row.thumbnailObj
          })]) : _vm.rowRInfoReady(scope.row) ? _c('img', {
            staticClass: "thumbnail_img",
            style: {
              width: '114px',
              height: '64px',
              objectFit: 'cover'
            },
            attrs: {
              "title": scope.row['peerId'],
              "src": scope.row['thumbnailObj'],
              "alt": "",
              "onerror": _vm.deafultImg
            }
          }) : _c('div', {
            staticClass: "live-preview-disabled-hint"
          })]) : _vm._e(), _vm.dropCol[index] == "source" ? _c('div', {
            class: [_vm.dropCol[index]]
          }, [_c('span', {
            staticClass: "status ellipsis",
            class: [_vm.getStatusClass(scope.row)],
            attrs: {
              "title": scope.row.source
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.copyDeviceInfo($event, scope.row.source);
              }
            }
          }, [_vm._v(" " + _vm._s(scope.row.source) + " ")])]) : _vm._e(), _vm.dropCol[index] == "pid" ? _c('div', {
            class: [_vm.dropCol[index]]
          }, [_c('span', {
            staticClass: "ellipsis",
            attrs: {
              "title": scope.row.peerId.toUpperCase()
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                _vm.copyDeviceInfo($event, scope.row.peerId.toUpperCase());
              }
            }
          }, [_vm._v(" " + _vm._s(scope.row.peerId.toUpperCase()) + " ")])]) : _vm._e(), _vm.dropCol[index] == "destination" ? _c('div', {
            staticClass: "r_box",
            class: [_vm.dropCol[index]],
            on: {
              "click": function ($event) {
                return _vm.prevent($event);
              }
            }
          }, [_c('select-source-r', {
            key: scope.row.peerId,
            attrs: {
              "sourceItem": scope.row,
              "sourceListItemOps": scope.row,
              "hadSelectDevice": _vm.isSelectNewR[scope.row.peerId],
              "from": "sourceList",
              "type": "T"
            },
            on: {
              "changeHadSelectDevice": _vm.changeHadSelectDevice,
              "getSelectInfo": _vm.getSelectInfo
            }
          })], 1) : _vm._e(), !"thumbnailObj,source,destination,battery,bookmark,bitrate,latency".includes(_vm.dropCol[index]) ? _c('div', {
            class: [_vm.dropCol[index]],
            attrs: {
              "title": "thumbnailObj,source,destination,battery,bookmark,bitrate,latency".includes(_vm.dropCol[index]) ? "" : scope.row[_vm.dropCol[index]]
            },
            domProps: {
              "innerHTML": _vm._s(scope.row[_vm.dropCol[index]])
            }
          }) : _vm._e(), _vm.dropCol[index] == "bookmark" ? _c('div', {
            class: [_vm.dropCol[index]]
          }, [_c('span', {
            staticClass: "bookmark_name pointer test",
            attrs: {
              "title": _vm.getBookmarkName(scope.row.userBookmarkDevice)
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.operationBookmarkBox(true, scope.row.userBookmarkDevice, scope.row.peerId);
              }
            }
          }, [_vm._v(_vm._s(_vm.getBookmarkName(scope.row.userBookmarkDevice)))])]) : _vm._e(), _vm.dropCol[index] == "battery" ? _c('div', [_c('div', {
            staticClass: "f_left clearfix"
          }, [_c('div', {
            staticClass: "battery1-box f_left"
          }, [_vm.isShowSpan1(scope.row.battery, scope.row) ? _c('span', {
            staticClass: "batterySpan f_left greenColor normalFamily"
          }, [_vm._v("N/A")]) : _c('div', {
            staticClass: "battery-moudel f_left",
            class: [Number(scope.row.battery.BAT1VAL) <= 20 ? 'redBorder' : ''],
            attrs: {
              "title": scope.row.battery.BAT1VAL + '%'
            }
          }, [_c('div', {
            staticClass: "battery-dot",
            class: [Number(scope.row.battery.BAT1VAL) <= 20 ? 'redBorder' : '']
          }), _c('div', {
            staticClass: "battery1-value",
            style: {
              width: `${scope.row.battery.BAT1VAL}%`
            }
          })]), scope.row.battery && (scope.row.battery.BAT1 == '2' || scope.row.battery.BAT1 == '0') ? _c('i', {
            staticClass: "iconfont battery-charging top_12 f_left left_5"
          }) : _vm._e()])])]) : _vm._e(), _vm.dropCol[index] == "bitrate" ? _c('div', [_c('div', {
            staticClass: "bitrate_box down_box pr"
          }, [scope.row.bitrateObj && scope.row.bitrateObj.bitrate ? _c('el-popover', {
            attrs: {
              "trigger": "click",
              "placement": "top",
              "popper-class": "bitrateDelayPopover"
            }
          }, [_vm.bitrateDelayInfo.show ? _c(_vm.editBitrateDelayWrap, {
            tag: "component",
            attrs: {
              "info": _vm.bitrateDelayInfo
            }
          }) : _vm._e(), _c('span', {
            staticClass: "down_triangle",
            class: {
              'noPointer': !scope.row.bitrateObj.allowSet
            },
            attrs: {
              "slot": "reference",
              "title": scope.row.bitrateObj && scope.row.bitrateObj.bitrate || ''
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.openDelayBitratePopover(scope.row, 'bitrate');
              }
            },
            slot: "reference"
          }, [_c('span', {
            staticClass: "normalFamily"
          }, [_vm._v(_vm._s(scope.row.bitrateObj && scope.row.bitrateObj.bitrate ? `${scope.row.bitrateObj.bitrate}Kbps` : ''))])])], 1) : _vm._e()], 1)]) : _vm._e(), _vm.dropCol[index] == "latency" ? _c('div', [_c('div', {
            staticClass: "bitrate_box down_box pr"
          }, [scope.row.latencyObj && scope.row.latencyObj.delay ? _c('el-popover', {
            attrs: {
              "trigger": "click",
              "placement": "top",
              "popper-class": "bitrateDelayPopover"
            }
          }, [_vm.bitrateDelayInfo.show ? _c(_vm.editBitrateDelayWrap, {
            tag: "component",
            attrs: {
              "info": _vm.bitrateDelayInfo
            }
          }) : _vm._e(), _c('span', {
            staticClass: "down_triangle",
            class: {
              'noPointer': !scope.row.latencyObj.allowSet
            },
            attrs: {
              "slot": "reference",
              "title": scope.row.latencyObj && scope.row.latencyObj.delay || ''
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.openDelayBitratePopover(scope.row, 'delay');
              }
            },
            slot: "reference"
          }, [_c('span', {
            staticClass: "normalFamily"
          }, [_vm._v(_vm._s(`${scope.row.latencyObj && scope.row.latencyObj.delay || ''} ${_vm.$t('lang.second')}`))])])], 1) : _vm._e()], 1)]) : _vm._e()];
        }
      }], null, true)
    }) : _vm._e()];
  }), _c('el-table-column', {
    attrs: {
      "class-name": "forbid_drag",
      "width": "123"
    }
  })], 2)], 1), _c('div', {
    staticClass: "operation_col",
    class: {
      shadow: _vm.hasShadow
    },
    style: {
      left: _vm.operationLeft
    }
  }, [_c('div', [_c('p', {
    staticClass: "f_left"
  }, [_vm._v(_vm._s(_vm.$t(`lang.operation`)))]), _c('el-dropdown', {
    attrs: {
      "hide-on-click": false
    },
    on: {
      "command": _vm.changeTitle
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "el-icon-more pointer el-icon--right"
  })]), _c('el-dropdown-menu', {
    staticClass: "devicelist_title_list",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.allTitle, function (item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": item
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.$t(`lang.${item}`)
      },
      model: {
        value: _vm.check[item],
        callback: function ($$v) {
          _vm.$set(_vm.check, item, $$v);
        },
        expression: "check[item]"
      }
    })], 1);
  }), 1)], 1)], 1), _vm._l(_vm.deviceList, function (item) {
    return _c('div', {
      key: item.peerId,
      staticClass: "device_box"
    }, [_c('div', {
      staticClass: "gridLiveEntry"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.type === 'X' && item.hasSlugPerimission,
        expression: "item.type === 'X' && item.hasSlugPerimission"
      }],
      staticClass: "iconfont icon-Dashboard",
      attrs: {
        "title": _vm.$t('lang.gridLogs')
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.openGridLogs(item);
        }
      }
    })]), _c('div', {
      staticClass: "device_btn",
      on: {
        "click": function ($event) {
          return _vm.prevent($event);
        }
      }
    }, [_c('video-button', {
      key: item.peerId,
      style: {
        'margin-left': '10px',
        'float': 'right',
        'width': '73px'
      },
      attrs: {
        "sourceItem": item,
        "hadSelectDevice": _vm.isSelectNewR[item.peerId],
        "flag": "T",
        "parentComponent": "sourceList",
        "deviceList": _vm.changeRArr[item.peerId]
      },
      on: {
        "changeHadSelectDevice": _vm.changeHadSelectDevice,
        "stopRState": _vm.stopRState
      }
    })], 1), _vm.expands[0] == item.peerId ? _c('div', {
      staticClass: "expend_box"
    }) : _vm._e()]);
  })], 2), _vm.isShow.bookmark ? _c(_vm.addBookmarkWrap, {
    tag: "component",
    attrs: {
      "visible": _vm.isShow,
      "lastBookmark": _vm.updateBookmarkObj.userBookmarkDevice,
      "deviceId": _vm.updateBookmarkObj.peerId,
      "deviceObj": {
        id: _vm.updateBookmarkObj.peerId,
        type: "MySource"
      }
    },
    on: {
      "closeBox": _vm.operationBookmarkBox
    }
  }) : _vm._e(), _vm.gridLogsInfo.show ? _c(_vm.gridLogsWrap, {
    tag: "component",
    attrs: {
      "info": _vm.gridLogsInfo
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }